var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRelevant)?_c('i',{staticClass:"tm-scroll-sensor",class:{
    v: _vm.MODE_DIAGNOSTIC,
  },style:(_vm.styleObj)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }